var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 13.125C9.61312 13.125 10.875 11.8631 10.875 10.3125V4.47312C10.875 3.72187 10.5825 3.01562 10.0512 2.48438L8.39062 0.82375C7.85937 0.2925 7.15375 0 6.40188 0H3.0625C1.51188 0 0.25 1.26188 0.25 2.8125V10.3125C0.25 11.8631 1.51188 13.125 3.0625 13.125H8.0625ZM9.60938 2.92625C9.845 3.16188 10.0125 3.44438 10.1194 3.75H7.75C7.40562 3.75 7.125 3.46937 7.125 3.125V0.755625C7.43062 0.8625 7.71312 1.03 7.94875 1.26562L9.60938 2.92625ZM0.875 10.3125V2.8125C0.875 1.60625 1.85625 0.625 3.0625 0.625H6.40188C6.435 0.625 6.46688 0.633125 6.5 0.634375V3.125C6.5 3.81437 7.06063 4.375 7.75 4.375H10.2406C10.2419 4.40812 10.25 4.44 10.25 4.47312V10.3125C10.25 11.5188 9.26875 12.5 8.0625 12.5H3.0625C1.85625 12.5 0.875 11.5188 0.875 10.3125ZM12.75 5.3125V12.1875C12.75 13.7381 11.4881 15 9.9375 15H2.4375C2.265 15 2.125 14.86 2.125 14.6875C2.125 14.515 2.265 14.375 2.4375 14.375H9.9375C11.1438 14.375 12.125 13.3938 12.125 12.1875V5.3125C12.125 5.14 12.265 5 12.4375 5C12.61 5 12.75 5.14 12.75 5.3125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardIcon);
export default __webpack_public_path__ + "static/media/clipboard_icon.5bc453629d8a4e9824374a46a7f9078b.svg";
export { ForwardRef as ReactComponent };